var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "classlist" },
    [
      _c("div", { staticClass: "list-top-box" }, [
        _c(
          "div",
          { staticClass: "list-top" },
          [
            _c("TopHead", {
              attrs: {
                "top-type": "black",
                title: _vm.spver === 1 ? _vm.listHead[_vm.listTab] : "搜狗视频",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "list-nav" }, [
              _c(
                "div",
                { staticClass: "list-nav-box" },
                _vm._l(_vm.listHead, function (value, key) {
                  return _c(
                    "a",
                    {
                      key: key,
                      class:
                        _vm.listTab === key
                          ? "list-nav-item cur"
                          : "list-nav-item",
                      attrs: {
                        "data-name": "all",
                        uigs: "list_type_" + key,
                        href: `/list?listTab=${key}${
                          _vm.spver ? "&spver=1" : ""
                        }`,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.classNavClick(value, key)
                        },
                      },
                    },
                    [_vm._v(_vm._s(value))]
                  )
                }),
                0
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.searchData &&
      _vm.searchData.list &&
      _vm.searchData.list.filter_list &&
      _vm.searchData.list.filter_list.length > 0
        ? [
            _c("ClassFilterNav", {
              attrs: {
                "filter-data": _vm.filterList,
                "filter-class-nav": _vm.filterClassNav,
                "get-uigs": _vm.getClassFilterUigs,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.searchData &&
      _vm.searchData.list &&
      _vm.videoType.indexOf(_vm.searchData.list.entity) < 0
        ? [
            _vm.classListData && _vm.classListData.length > 0
              ? _c("ClassList", {
                  attrs: {
                    "data-list": _vm.classListData,
                    type: _vm.searchData.list.entity,
                    "get-uigs": _vm.getUigs,
                    "show-loading": !_vm.loadingFinished,
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.searchData &&
      _vm.searchData.list &&
      _vm.videoType.indexOf(_vm.searchData.list.entity) >= 0
        ? [
            _c("ShortVideo", {
              attrs: {
                "short-video": _vm.classListData,
                "get-uigs": _vm.getUigs,
                "show-loading": !_vm.loadingFinished,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      [
        !_vm.classListData || _vm.classListData.length === 0
          ? _c("div", { staticClass: "class-list-noresult" }, [
              _c("div", { staticClass: "class-list-noresult-box" }, [
                _c("p", [_vm._v("抱歉，未能找到符合条件的影片")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.searchData && _vm.searchData.list,
                        expression: "searchData && searchData.list",
                      },
                    ],
                    staticClass: "empty-btn",
                    on: {
                      click: function ($event) {
                        return _vm.filterClassNav(-1, -1, true)
                      },
                    },
                  },
                  [_vm._v("清空筛选")]
                ),
              ]),
            ])
          : _vm._e(),
      ],
      _vm._v(" "),
      _c("Gotop"),
      _vm._v(" "),
      false ? _c("div", { staticClass: "list-banner" }) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }